import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
export function StickyCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 700);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-177" data-mp="3peam4j0ug885">
      {visible ? <motion.div initial={{
      opacity: 0,
      y: 24
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 24
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="pointer-events-none fixed inset-x-0 bottom-5 z-50 flex justify-center px-6" data-id="element-178" data-mp="3ud563oajs2tu">
          <div className="pointer-events-auto" data-id="element-179" data-mp="c5xuddvasdpg">
            <CtaButton source="sticky" data-id="element-180" data-mp="c55z645m4hzp" />
          </div>
        </motion.div> : null}
    </AnimatePresence>;
}